/* eslint-disable react/button-has-type */
/** @jsx jsx */
import { jsx } from 'theme-ui';
// import { MdSearch } from 'react-icons/md';
import Link from '../link';
import logo from '../../images/CMEGroupLogo.svg';

export const Container = (props) => (
  <div
    sx={{
      display: 'flex',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
      height: ['5.8rem', null, 'auto'],
      pr: ['1.4rem', '2.8rem', 0],
      position: 'relative',
      // zIndex: 51,
      bg: 'white',
    }}
    {...props}
  />
);

export const LogoLink = (props) => (
  <Link
    sx={{
      backgroundImage: `url(${logo})`,
      backgroundSize: 'contain',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'left center',
      width: '15.7rem',
      display: 'inline-block',
      ml: ['1.5rem', '2.8rem', '6.4rem'],
    }}
    {...props}
  />
);

export const SearchContainer = (props) => (
  <div
    sx={{
      display: 'flex',
      alignItems: 'center',
      height: [null, null, '6.4rem'],
      pr: [null, null, '6.4rem'],
    }}
    {...props}
  />
);

export const SearchButton = (props) => (
  <button
    sx={{
      mx: '1.4rem',
      cursor: 'pointer',
    }}
    {...props}
  />
);
